import axios from 'axios';
import { PostConsumptionBodyType, PostConsumptionResponseType } from './type';
import config from '../config-api.json';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

const getCookie = function (name: string) {
  const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  if (value) {
    if (value[2] !== 'undefined') {
      return value[2];
    }
    return null;
  }
  return null;
};

export async function apiPostConsumption(info: PostConsumptionBodyType) {
  const response = await axios.post<PostConsumptionResponseType>(
    `${apiInfo.api_url}/consumption/`,
    {
      session: getCookie('voda_sid'),
      user_id: localStorage.getItem('voda_uid'),
      search_word: localStorage.getItem('aivory_search_keyword'),
      ...info,
    }
  );

  return response.data;
}

export { apiPostConsumption as default };
